export default class CallRecord {
  time: Date
  roomId: string
  status: string
  constructor (time: Date, roomId: string, status: string) {
    this.time = time
    this.roomId = roomId
    switch (status) {
      case 'calling':
        this.status = '響鈴中'
        break
      case 'miss':
        this.status = '未接通'
        break
      case 'connected':
        this.status = '已接通'
        break
      case 'hang-up':
        this.status = '已掛斷'
        break
      default:
        this.status = '-'
    }
  }
}
